import '../scss/main.scss';

$(function () {
  const PREVIEW_MAX = 40;
  $('.faq_list .faq_list--item').each(function () {
    const $ans = $(this).find('.answer');
    const fullHtml = $ans.html();
    const fullText = $ans.text().replace(/\s+/g,' ').trim();

    $ans.data('full-html', fullHtml);

    if (fullText.length > PREVIEW_MAX) {
      const preview = fullText.slice(0, PREVIEW_MAX) + '…';
      $ans.text(preview);
    }
  });

  const $modal   = $('#faqModal');
  const $title   = $('#faqModalTitle');
  const $content = $('#faqModalDesc');
  let scrollY = 0, $lastFocus = null;

  $('.faq_list').on('click', '.faq_list--item, .read_more', function(e){
    if ($(e.target).closest('.read_more').length) e.stopPropagation();
    const $li   = $(this).closest('.faq_list--item');
    const q     = $li.find('.question').text().trim();
    const $full = $li.find('.answer-full');
    const html  = $full.length ? $full.html() : ($li.find('.answer').data('full-html') || $li.find('.answer').html());


    openModal(q, html, e.currentTarget);
  });

  function openModal(q, html, trigger){
    $title.text(q);
    $content.html(html);
    scrollY = window.scrollY || document.documentElement.scrollTop;
    $('body').addClass('modal-open').css('top', -scrollY + 'px');
    $modal.attr('aria-hidden','false').addClass('is-open');
    $lastFocus = $(trigger);
    $modal.find('.faq-modal__close').trigger('focus');
    $(document).on('keydown.faq', e => { if (e.key === 'Escape') closeModal(); });
  }
  function closeModal(){
    $modal.attr('aria-hidden','true').removeClass('is-open');
    $('body').removeClass('modal-open').css('top','');
    window.scrollTo(0, scrollY);
    if ($lastFocus && $lastFocus.length) $lastFocus.trigger('focus');
    $(document).off('keydown.faq');
  }
  $modal.on('click', '[data-close-modal]', closeModal);
  $modal.on('click', '.faq-modal__dialog', e => e.stopPropagation());
});


$(function () {
  function initSlider($el){
    if ($el.hasClass('slick-initialized')) {
      $el.slick('setPosition');
      return;
    }
    $el.slick({
      slidesToShow: 1,
      dots: false,
      arrows: false,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 1500,
      mobileFirst: true,
    });
  }

  // 768px以上は解除
  function upDown($el){
    if ($(window).width() < 768) {
      if ($el.is(':visible') && $el.width() > 0) initSlider($el);
    } else if ($el.hasClass('slick-initialized')) {
      $el.slick('unslick');
    }
  }

  // 可視判定で初期化（pickup優先）
  const io = new IntersectionObserver((entries)=>{
    entries.forEach(e=>{
      if (e.isIntersecting) {
        const $t = $(e.target);
        upDown($t);
        // 一度初期化したら監視解除
        io.unobserve(e.target);
      }
    });
  }, { root: null, threshold: 0.1 });

  const $pickup = $('.pickup_list');   // ← pick-up だけ確実に可視になってから
  if ($pickup.length) io.observe($pickup[0]);

  // lineup/category は従来通り
  $('.category').each(function(){
    const $t = $(this);
    if ($t.is(':visible') && $t.width() > 0 && $(window).width() < 768) initSlider($t);
  });

  // 画像読み込み後に再計算
  $(window).on('load', function(){
    $('.pickup_list, .category').each(function(){
      if ($(this).hasClass('slick-initialized')) $(this).slick('setPosition');
    });
  });

  // リサイズ・向き変更
  let rt;
  $(window).on('resize orientationchange', function(){
    clearTimeout(rt);
    rt = setTimeout(function(){
      $('.pickup_list, .category').each(function(){ upDown($(this)); });
    }, 250);
  });
});
